// @flow

// creates a global script tag unless it's already been created
export default (
  { src, id, data = {} }: {| src: string, id: string, data?: { [key: string]: string } |},
  callback?: () => void,
) => {
  try {
    if (document.querySelector(`#${id}`)) {
      return;
    }
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error(e);
  }
  const script = document.createElement('script');
  script.setAttribute('src', src);
  script.setAttribute('id', id);
  script.setAttribute('defer', '');
  Object.keys(data).forEach((key: string) => {
    script.setAttribute(key, data[key]);
  });
  if (callback) {
    script.addEventListener('load', callback);
  }

  if (document.head) {
    document.head.appendChild(script);
  }
};
